import { Card } from "primereact/card";
import { SelectButton } from "primereact/selectbutton";
import React, { useEffect, useState } from "react";
import { getAllCourses } from "../services/courses";
import "../styles/Courses.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { formatToCamelCase } from "../Components/custom/Helpers";
import { Helmet } from "react-helmet-async";

const Courses = () => {
  const { category } = useParams();
  const [courses, setCourses] = useState([]);

  const [value, setValue] = useState(formatToCamelCase(category) || "Beginner");
  const [selectedCourseType, setSelectedCourseType] = useState(
    formatToCamelCase(category) || "Beginner"
  );
  const items = [
    { name: "Beginner", value: "Beginner" },
    { name: "Intermediate", value: "Intermediate", className: "px-4" },
    { name: "Refresher", value: "Refresher" },
  ];
  let navigate = useNavigate();
  const handleCoursetypeChange = (e) => {
    const newCourseType = e.value;
    if (!newCourseType || newCourseType === value) {
      return;
    }
    setSelectedCourseType(newCourseType);
    setValue(newCourseType);
    navigate(`/courses/${newCourseType.toLowerCase()}`);
  };

  // const [coursesContent, setCoursesContent] = useState();
  // useEffect(() => {
  //   fetchPages();
  // }, [selectedCourseType]);
  // const fetchPages = async () => {
  //   const response = await fetch(
  //     `/api/wp/pages/${selectedCourseType.toLocaleLowerCase()}-courses`
  //   );
  //   console.log(response);
  //   const textResponse = await response.text();
  //   setCoursesContent(textResponse);
  // };
  const getCourses = async () => {
    await getAllCourses()
      .then((data) => {
        setCourses(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    // const queryParams = new URLSearchParams(location.search);
    // const courseType = queryParams.get("courseType");
    // setSelectedCourseType(courseType ? courseType : "Beginner");

    // setValue(courseType ? courseType : "Beginner");
    const initialCourseType = category
      ? category.charAt(0).toUpperCase() + category.slice(1)
      : "Beginner";
    setSelectedCourseType(initialCourseType);
    getCourses();
  }, []);
  const courseCategoryContent = {
    Beginner: `
    For new drivers seeking to build a strong foundation, these courses offer everything you need to get started on the road with confidence. 
    Ideal for individuals with no prior driving experience, it provides a structured introduction to the essential rules of the road, basic driving techniques, and critical safety protocols. 
    These courses include <strong>step-by-step guidance</strong> on key driving fundamentals, such as <strong>understanding traffic signs</strong>, <strong>mastering vehicle control</strong>, and <strong>adhering to road safety practices</strong>. 
    With a focus on <strong>instilling safe driving habits</strong> from the outset, these courses ensure that new learners are well-equipped to handle various driving scenarios while <strong>developing the confidence</strong> needed to navigate the road safely and effectively.
  `,

    Intermediate: `
    Enhance your driving skills and build lasting confidence on the road with our expertly designed programs, ideal for drivers with some prior experience who want to further refine their abilities. 
    These courses provide comprehensive training on <strong>mastering a wide range of traffic scenarios</strong>, from busy urban intersections to highway driving, and teach you how to <strong>navigate complex road environments</strong> with greater ease and control. 
    You’ll <strong>gain valuable insights</strong> into handling challenging driving conditions, <strong>improving vehicle maneuverability</strong>, and <strong>responding confidently to real-world road situations</strong>. 
    Whether you're looking to refresh your skills or advance your driving expertise, these courses will help you feel <strong>fully prepared and capable on the road</strong>.
  `,

    Refresher: `
    These comprehensive programs are designed for individuals who need a quick yet thorough refresher on driving. 
    Whether you are a driver looking to <strong>regain confidence</strong> after time away from the road or someone who wants to <strong>update their skills</strong> to meet the demands of today's driving environment, these courses are ideal. 
    They focus on <strong>defensive driving techniques</strong>, <strong>situational awareness</strong>, and <strong>adapting to modern traffic patterns</strong>. 
    Additionally, these courses cover essential <strong>updates in road regulations</strong>, <strong>tips for handling new vehicle technologies</strong>, and best practices for navigating complex driving scenarios such as <strong>urban traffic</strong>, <strong>highway merging</strong>, and <strong>roundabouts</strong>. 
    Perfect for drivers of all levels who wish to ensure they are <strong>up-to-date and prepared for today's roads</strong>.
  `,
  };

  const renderCourses = () => {
    return courses
      .filter((course) => course.category === selectedCourseType)
      .map((course, index) => (
        <div key={index} className="card-container">
          <Card
            title={() => (
              <>
                <i className="pi pi-clock" style={{ fontSize: "20px" }} />{" "}
                {course.hours} Hours Course <br />
                <i
                  className="pi pi-calendar"
                  style={{ fontSize: "20px" }}
                />{" "}
                {course.duration}
              </>
            )}
            // subTitle={() => (
            //   <>
            //     <i className="pi pi-pound" style={{ color: "white" }} />
            //     <strong style={{ fontSize: "20px", color: "white" }}>
            //       {course.price}
            //     </strong>
            //   </>
            // )}
            className="md:w-25rem course-card"
            footer={() => (
              <div className="d-flex justify-content-center">
                {/* <Link to="/booking"> */}
                <Link
                  to={`/booking?courseId=${course.id}&courseType=${selectedCourseType}`}
                >
                  <button
                    className={`btn course-button ${selectedCourseType.toLowerCase()} mx-1`}
                  >
                    Book Now
                  </button>
                </Link>
                <Link to={`/course/${course?.slug}`}>
                  <button
                    className={`btn course-button ${selectedCourseType.toLowerCase()}-inverse mx-1 `}
                  >
                    View Details
                  </button>
                </Link>
              </div>
            )}
          >
            <>
              <div
                className="card-content mb-5 px-2 "
                style={{ textAlign: "justify" }}
                dangerouslySetInnerHTML={{ __html: course.details }}
              ></div>
              {course.price && (
                <div style={{ textAlign: "justify" }}>
                  <strong style={{ fontSize: "20px", color: "white" }}>
                    From Price{" "}
                    <span
                      className={
                        course?.discounted_from_price &&
                        course?.discounted_from_price < course?.from_price
                          ? "text-decoration-line-through"
                          : ""
                      }
                      style={
                        course?.discounted_from_price &&
                        course?.discounted_from_price < course?.from_price
                          ? { fontSize: "17px" }
                          : {}
                      }
                    >
                      £{course.from_price}
                    </span>
                    {course?.discounted_from_price &&
                      course?.discounted_from_price < course?.from_price && (
                        <span className="ml-1 text-quaternary">
                          {" "}
                          £{course.discounted_from_price}
                        </span>
                      )}
                  </strong>
                </div>
              )}
            </>
          </Card>
        </div>
      ));
  };

  return (
    <div className="mt-5">
      <Helmet>
        <title>{selectedCourseType} Courses - Pass Swiftly</title>
        <meta
          name="description"
          content={`Browse Pass Swiftly's comprehensive driving courses for ${selectedCourseType}s. Find the right course to match your needs and become a confident driver.`}
        />
      </Helmet>
      <h1 className="text-center m-4">Courses</h1>
      <div className="d-flex justify-content-center m-4">
        <SelectButton
          value={value}
          onChange={handleCoursetypeChange}
          optionLabel="name"
          options={items}
          className="md:w-25rem d-flex flex-row justify-content-center align-items-center"
        />
      </div>
      <div className="text-center container text-lg">
        <h2>{selectedCourseType} Courses Overview</h2>
        <p
          style={{ textAlign: "justify", lineHeight: "1.8" }}
          dangerouslySetInnerHTML={{
            __html: courseCategoryContent[selectedCourseType],
          }}
        >
          {/* {courseCategoryContent[selectedCourseType]} */}
        </p>
      </div>
      {/* <Routes>
        <Route path="/:beginner" />
      </Routes> */}
      <div className="d-flex flex-wrap justify-content-center">
        {selectedCourseType && renderCourses()}
      </div>

      {/* <div className="container mt-2">
        {coursesContent ? (
          <div
            style={{ fontFamily: "sans-serif" }} // Style your HTML content
            dangerouslySetInnerHTML={{ __html: coursesContent }} // Render HTML safely
          ></div>
        ) : (
          <p className="text-center mt-5">
            {" "}
            <i className="pi pi-spin pi-spinner fs-1" />
          </p>
        )}
      </div> */}
    </div>
  );
};

export default Courses;

// import { Card } from "primereact/card";
// import { SelectButton } from "primereact/selectbutton";
// import React, { useEffect, useState } from "react";
// import { getAllCourses } from "../services/courses";

// const Courses = () => {
//   const [value, setValue] = useState(null);
//   const items = [
//     { name: "Beginner", value: "Beginner" },
//     { name: "Intermediate", value: "Intermediate" },
//     { name: "Refresher", value: "Refresher" },
//   ];
//   const [courses, setCourses] = useState([]);
//   const [selectedCourseType, setSelectedCourseType] = useState("");
//   const handleCoursetypeChange = (e) => {
//     setSelectedCourseType(e.target.value);
//     console.log(e.target.value);
//     setValue(e.target.value);
//   };
//   const getCourses = async () => {
//     await getAllCourses()
//       .then((data) => {
//         setCourses(data);
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//   };

//   useEffect(() => {
//     getCourses();
//   }, []);
//   const refresherCourses = courses.filter(
//     (course) => course.category === "Refresher"
//   );
//   const intermediateCourses = courses.filter(
//     (course) => course.category === "Intermediate"
//   );
//   const beginnerCourses = courses.filter(
//     (course) => course.category === "Beginner"
//   );
//   const footer = () => {
//     return (
//       <div className="d-flex justify-content-end">
//         <button className="">Book Now</button>
//       </div>
//     );
//   };
//   return (
//     <div>
//       <h1 className="text-center">Courses</h1>
//       <div className="d-flex justify-content-center">
//         <SelectButton
//           value={value}
//           onChange={handleCoursetypeChange}
//           optionLabel="name"
//           options={items}
//           // multiple
//           className="md:w-25rem d-flex flex-row justify-content-center align-items-center"
//         />
//       </div>
//       {selectedCourseType === "Beginner" && (
//         <div
//         //   className="card flex justify-content-center"
//         >
//           <Card
//             //   header={() => <strong className="mx-3 mt-4">48 hours Course</strong>}
//             title={() => {
//               return (
//                 <>
//                   <i
//                     className="pi pi-clock"
//                     style={{ color: "", fontSize: "20px" }}
//                   />{" "}
//                   48 Hours Course <br />
//                   <i
//                     className="pi pi-calendar"
//                     style={{ color: "", fontSize: "20px" }}
//                   />{" "}
//                   4-10 weeks duration
//                 </>
//               );
//             }}
//             subTitle={() => (
//               <>
//                 <i className="pi pi-pound" />
//                 <strong className="" style={{ fontSize: "20px" }}>
//                   500
//                 </strong>
//               </>
//             )}
//             className="md:w-25rem"
//             footer={footer}
//           >
//             <p>
//               You're eager to hop in the driver's seat and begin your learning
//               journey. This course is perfect for newcomers, providing ample
//               time for hands-on experience. It is a 48-hour program which is
//               flexible and duration can be tailored to suit your preferences.
//             </p>
//           </Card>
//         </div>
//       )}
//       <div
//       //   className="card flex justify-content-center"
//       >
//         <Card
//           //   header={() => <strong className="mx-3 mt-4">48 hours Course</strong>}
//           title={() => {
//             return (
//               <>
//                 <i
//                   className="pi pi-clock"
//                   style={{ color: "", fontSize: "20px" }}
//                 />{" "}
//                 48 Hours Course <br />
//                 <i
//                   className="pi pi-calendar"
//                   style={{ color: "", fontSize: "20px" }}
//                 />{" "}
//                 4-10 weeks duration
//               </>
//             );
//           }}
//           subTitle={() => (
//             <>
//               <i className="pi pi-pound" />
//               <strong className="" style={{ fontSize: "20px" }}>
//                 500
//               </strong>
//             </>
//           )}
//           className="md:w-25rem"
//           footer={footer}
//         >
//           <p>
//             You're eager to hop in the driver's seat and begin your learning
//             journey. This course is perfect for newcomers, providing ample time
//             for hands-on experience. It is a 48-hour program which is flexible
//             and duration can be tailored to suit your preferences.
//           </p>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default Courses;

// // <div
// // //   className="card flex justify-content-center"
// // >
// //   <Card
// //     //   header={() => <strong className="mx-3 mt-4">48 hours Course</strong>}
// //     title={() => {
// //       return (
// //         <>
// //           <i
// //             className="pi pi-clock"
// //             style={{ color: "", fontSize: "20px" }}
// //           />{" "}
// //           48 Hours Course <br />
// //           <i
// //             className="pi pi-calendar"
// //             style={{ color: "", fontSize: "20px" }}
// //           />{" "}
// //           4-10 weeks duration
// //         </>
// //       );
// //     }}
// //     subTitle={() => (
// //       <>
// //         <i className="pi pi-pound" />
// //         <strong className="" style={{ fontSize: "20px" }}>
// //           500
// //         </strong>
// //       </>
// //     )}
// //     className="md:w-25rem"
// //     footer={footer}
// //   >
// //     <p>
// //       You're eager to hop in the driver's seat and begin your learning
// //       journey. This course is perfect for newcomers, providing ample time
// //       for hands-on experience. It is a 48-hour program which is flexible
// //       and duration can be tailored to suit your preferences.
// //     </p>
// //   </Card>
// // </div>
